/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';;
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Divider from '@material-ui/core/Divider';
import { CustomFixedDeductionTableTable } from './FixedDeductionTable';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    }
}));

export default function DeductionTemplateAddEdit(props) {
    const classes = useStyles();
    const screenCode = 'DEDUCTIONTEMPLATE';
    const navigate = useNavigate();
    const [isButtonEnable, setIsButtonEnable] = useState(false);
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [deductionTypes, setDeductionTypes] = useState([]);
    const [finalFixdedDeductionTable, setFinalFixdedDeductionTable] = useState([]);
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        deductionTypeID: "0",
        isFixed: false,
        isActive: true,
        isDefaultValueEnabled: false,
        applyMethodID: '0',
        deductionSequence: '0',
        deductionOrder: '0',
        defaultValue: 0,
        minimumValue: 0
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add Deduction"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const UserRoleSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required'),
        operationEntityID: Yup.number().min(1, 'Please select a OperationEntity').required('OperationEntity Required'),
        deductionTypeID: Yup.number().min(1, 'Please select a Deduction Type').required('Deduction Type Required'),
        applyMethodID: Yup.number().min(1, 'Please select a Apply Method').required('Apply Method Required'),
        deductionOrder: Yup.number().min(0, 'Please Enter a valid Deduction Order'),
        deductionSequence: Yup.number().min(1, 'Please Enter a valid Deduction Sequence').required('Deduction Sequence is Required')
    });

    const { operationEntityID } = useParams();
    let decrypted = 0;

    useEffect(() => {
        decrypted = AESDecryptionParam(operationEntityID);
        if (decrypted != 0) {
            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit Deduction Template"
            })
        }
    }, []);

    useEffect(() => {

        if (pageProps.editingID > '0') {
            trackPromise(setForEdit(pageProps.editingID))
        }

    }, [pageProps.editingID]);

    async function setForEdit(id) {
        var deductionTemplate = await services.GetdeductionTemplatedetailsByTemplateID(id);
        for (let i = 0; i < deductionTemplate.data.length; i++) {
            deductionTemplate.data[i].rowIndex = i
        }
        if (deductionTemplate != null) {
            setValues({
                groupID: deductionTemplate.groupID,
                operationEntityID: deductionTemplate.operationEntityID,
                deductionTypeID: deductionTemplate.deductionTypeID,
                isActive: deductionTemplate.isActive,
                isDefaultValueEnabled: deductionTemplate.isDefaultValueEnabled,
                isFixed: deductionTemplate.isFixed,
                applyMethodID: deductionTemplate.applyMethodID,
                deductionSequence: deductionTemplate.deductionSequence,
                deductionOrder: deductionTemplate.deductionOrder,
                minimumValue: deductionTemplate.minimumValue,
                defaultValue: deductionTemplate.defaultValue
            })
            setFormData(deductionTemplate)
            setFinalFixdedDeductionTable(deductionTemplate.data)
        }
    }

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            deductionTypeID: formData.deductionTypeID,
            isActive: formData.isActive,
            isDefaultValueEnabled: formData.isDefaultValueEnabled,
            isFixed: formData.isFixed,
            applyMethodID: formData.applyMethodID,
            deductionSequence: formData.deductionSequence,
            deductionOrder: formData.deductionOrder,
            minimumValue: formData.minimumValue,
            defaultValue: formData.defaultValue
        },

        validationSchema: UserRoleSearchSchema,

        onSubmit: (values) => {
            if (pageProps.isEdit != 0) {
                trackPromise(UpdateDeductionTemplate(values, pageProps.editingID));
            } else {
                trackPromise(SaveDeductionTemplate(values));
            }
        },
    });

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetAvailableDeductionTypes());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        if (pageProps.editingID == 0) {
            setValues({
                ...values,
                defaultValue: "0",
                minimumValue: "0"
            })
        }
    }, [formik.values.isDefaultValueEnabled]);

    useEffect(() => {
        if (pageProps.editingID == 0) {
            setValues({
                ...values,
                deductionTypeID: "0",
                isFixed: false,
                isActive: true,
                isDefaultValueEnabled: false,
                applyMethodID: '0',
                deductionSequence: '0',
                deductionOrder: '0',
                defaultValue: 0,
                minimumValue: 0
            })

            setFinalFixdedDeductionTable([])
        }
    }, [formik.values.operationEntityID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDEDUCTIONTEMPLATE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        });
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    async function GetAvailableDeductionTypes() {
        let filterModel = {
            operationEntityID: parseInt(formik.values.operationEntityID),
            groupID: parseInt(formik.values.groupID)
        }
        var res = await services.getAvailableDeductionTypes(filterModel);
        if (res != null) {
            setDeductionTypes(res);
        }
    }

    function generateOperationEntityForDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.factoryID} value={x.factoryID}>{x.factoryName}</MenuItem>)
            });
        }
        return items
    }

    async function SaveDeductionTemplate(values) {
        var selected = finalFixdedDeductionTable.filter(x => x.fixedDeductionName != "" && x.fixedDeductionValue != 0)
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: values.operationEntityID,
            deductionTypeID: values.deductionTypeID,
            isActive: values.isActive,
            isDefaultValueEnabled: values.isDefaultValueEnabled,
            isFixed: values.isFixed,
            applyMethodID: values.applyMethodID,
            deductionSequence: parseInt(values.deductionSequence),
            deductionOrder: parseInt(values.deductionOrder),
            defaultValue: parseFloat(values.defaultValue),
            minimumValue: parseFloat(values.minimumValue),
            createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
            fixedDeductions: selected
        }
        var res = await services.SaveDeductionTemplate(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            setTimeout(() => {
                navigate('/dashboard/deductiontemplate');
                setIsButtonEnable(true);
            }, 3000);

        } else {
            toast.error(res.message);
        }
    }

    async function UpdateDeductionTemplate(values, deductionTemplateID) {
        var selected = finalFixdedDeductionTable.filter(x => x.fixedDeductionName != "" && x.fixedDeductionValue != 0)
        let model = {
            deductionTemplateID: parseInt(deductionTemplateID),
            groupID: parseInt(values.groupID),
            operationEntityID: values.operationEntityID,
            deductionTypeID: values.deductionTypeID,
            isActive: values.isActive,
            isDefaultValueEnabled: values.isDefaultValueEnabled,
            isFixed: values.isFixed,
            applyMethodID: values.applyMethodID,
            deductionSequence: parseInt(values.deductionSequence),
            deductionOrder: parseInt(values.deductionOrder),
            defaultValue: parseFloat(values.defaultValue),
            minimumValue: parseFloat(values.minimumValue),
            createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
            fixedDeductions: selected
        }
        var res = await services.EditDeductionTemplate(model);
        if (res.statusCode === "Success") {
            toast.success(res.message);
            setTimeout(() => {
                navigate('/dashboard/deductiontemplate');
                setIsButtonEnable(true);
            }, 3000);
        } else {
            toast.error(res.message);
        }
    }

    async function handleSpecialDeductionChange(e) {
        const target = e.target
        const value = target.type === 'checkbox' ? target.checked : target.value

        if (target.name === "isDefaultValueEnabled") {
            if (value) {
                setValues({
                    ...values,
                    [e.target.name]: value,
                    "isFixed": false,
                    "isDefaultValueEnabled": true
                })
            }
            else {
                setValues({
                    ...values,
                    [e.target.name]: value,
                    "isDefaultValueEnabled": false
                })
            }
        }
        else {

            if (value) {
                setValues({
                    ...values,
                    [e.target.name]: value,
                    "isFixed": true,
                    "isDefaultValueEnabled": false
                })
            }
            else {
                setValues({
                    ...values,
                    [e.target.name]: value,
                    "isFixed": false,
                })
            }
        }
    }

    function clearAll() {
        setValues({
            ...values,
            operationEntityID: "0",
            deductionTypeID: "0",
            isFixed: false,
            isActive: true,
            isDefaultValueEnabled: false,
            applyMethodID: '0',
            deductionSequence: '0',
            deductionOrder: '0',
            defaultValue: 0,
            minimumValue: 0
        })
    }

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    return (
        <>
            <LoadingComponent />
            <Page title="Deduction Template |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/deductiontemplate"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Fresh Collection Center</MenuItem>
                                        {generateOperationEntityForDropDownMenu(operationEntityList)}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Deduction Type *"
                                        value={formik.values.deductionTypeID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('deductionTypeID')}
                                        error={Boolean(touched.deductionTypeID && errors.deductionTypeID)}
                                        helperText={touched.deductionTypeID && errors.deductionTypeID}
                                    >
                                        <MenuItem key={0} value={0}> Select Deduction Type </MenuItem>
                                        {deductionTypes.map(deductionTypes => (
                                            <MenuItem key={deductionTypes.deductionTypeID} value={deductionTypes.deductionTypeID}>{deductionTypes.deductionTypeName}</MenuItem>
                                        ))}

                                    </TextField>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Apply Method *"
                                        value={formik.values.applyMethodID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('applyMethodID')}
                                        error={Boolean(touched.applyMethodID && errors.applyMethodID)}
                                        helperText={touched.applyMethodID && errors.applyMethodID}
                                    >
                                        <MenuItem key={0} value={0}> Select Apply Method</MenuItem>
                                        <MenuItem value={1}> Percentage </MenuItem>
                                        <MenuItem value={2}> Flat </MenuItem>
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Deduction Order"
                                        type='number'
                                        defaultValue={0}
                                        value={formik.values.deductionOrder}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('deductionOrder')}
                                        error={Boolean(touched.deductionOrder && errors.deductionOrder)}
                                        helperText={touched.deductionOrder && errors.deductionOrder}
                                    />
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Deduction Sequence *"
                                        type='number'
                                        defaultValue={0}
                                        value={formik.values.deductionSequence}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('deductionSequence')}
                                        error={Boolean(touched.deductionSequence && errors.deductionSequence)}
                                        helperText={touched.deductionSequence && errors.deductionSequence}
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isActive}
                                                checked={formik.values.isActive}
                                                {...getFieldProps('isActive')}
                                                onClick={formik.handleChange}
                                                color='error'
                                                name="isActive"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Active"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isFixed}
                                                checked={formik.values.isFixed}
                                                {...getFieldProps('isFixed')}
                                                onChange={(e) => handleSpecialDeductionChange(e)}
                                                type="checkbox"
                                                color='error'
                                                name="isFixed"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Fixed Deductions"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isDefaultValueEnabled}
                                                checked={formik.values.isDefaultValueEnabled}
                                                {...getFieldProps('isDefaultValueEnabled')}
                                                onChange={(e) => handleSpecialDeductionChange(e)}
                                                color='error'
                                                type="checkbox"
                                                name="isDefaultValueEnabled"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Default Deduction Enabled"
                                    />
                                </Stack>
                                {formik.values.isDefaultValueEnabled == true ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Default Value"
                                            type='number'
                                            value={formik.values.defaultValue}
                                            onChange={formik.handleChange}
                                            onKeyDown={(evt) =>
                                                (evt.key === "-") && evt.preventDefault()
                                            }
                                            InputProps={{
                                                inputProps: {
                                                    step: 0.01,
                                                    type: 'number',
                                                },
                                            }}
                                            {...getFieldProps('defaultValue')}
                                            error={Boolean(touched.defaultValue && errors.defaultValue)}
                                            helperText={touched.defaultValue && errors.defaultValue}
                                        />
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Minimum Value"
                                            type='number'
                                            value={formik.values.minimumValue}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('minimumValue')}
                                            error={Boolean(touched.minimumValue && errors.minimumValue)}
                                            helperText={touched.minimumValue && errors.minimumValue}
                                        />
                                    </Stack>
                                    : null}
                                {formik.values.isFixed == true ?
                                    <>
                                        <Divider variant="middle" />
                                        <CustomFixedDeductionTableTable
                                            setFinalFixdedDeductionTable={setFinalFixdedDeductionTable}
                                            finalFixdedDeductionTable={finalFixdedDeductionTable}
                                        />
                                        <Divider variant="middle" />
                                    </>
                                    : null}
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    {pageProps.editingID == 0 ?
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        : null}
                                    <Button
                                        disabled={isButtonEnable}
                                        type="submit"
                                        variant="contained"
                                        color='secondary'
                                    >{pageProps.submitButtonName}</Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}